import React, { useState } from "react";
import { Select } from "antd";
import styles from "./style.module.scss";
import SearchIcon from "assets/icons/SearchIcon";
import EmptyState from "./EmptyState";
import { SelectOption } from "./SelectOption";

export type Option = {
  label: string;
  value: string;
  title?: string;
};

export interface SelectListProps {
  options: Option[];
  value?: string[];
  defaultValue?: string[];
  placeholder?: string;
  disabled?: boolean;
  allowClear?: boolean;
  onChange?: (value: string[]) => void;
  loading?: boolean;
  mode?: "multiple";
  open?: boolean;
  placement?: "topLeft" | "topRight" | "bottomLeft" | "bottomRight";
  onDropdownVisibleChange?: (open: boolean) => void;
}

export default function SelectList({
  options,
  defaultValue,
  placeholder = "Please select",
  disabled = false,
  allowClear = true,
  onChange,
  value,
  loading = false,
  mode,
  open,
  placement,
  onDropdownVisibleChange,
}: SelectListProps) {
  const [selectedValues, setSelectedValues] = useState<string[]>(
    value || defaultValue || []
  );

  return (
    <div className={styles.selectWrapper}>
      <div className={styles.icon}>
        <SearchIcon />
      </div>
      <Select<string[], Option>
        mode={mode}
        open={open}
        autoFocus={true}
        suffixIcon={<SearchIcon />}
        loading={loading}
        allowClear={allowClear}
        showSearch={true}
        placement={placement}
        filterOption={(input, option) =>
          (option?.label || "")
            .toLowerCase()
            .includes(input.toLowerCase().trim())
        }
        placeholder={placeholder}
        disabled={disabled}
        defaultValue={defaultValue}
        value={value}
        options={options.map((o) => ({ ...o, title: "" }))}
        menuItemSelectedIcon={null}
        className={styles.select}
        notFoundContent={<EmptyState />}
        onDropdownVisibleChange={onDropdownVisibleChange}
        onChange={(val) => {
          setSelectedValues(val);
          onChange?.(val);
        }}
        onClear={() => {
          setSelectedValues([]);
          onChange?.([]);
        }}
        optionRender={(option) => {
          const value = option?.value as string;
          const label = option?.label as string;
          return (
            <SelectOption
              selectedValues={selectedValues}
              value={value}
              label={label}
            />
          );
        }}
      />
    </div>
  );
}
